module.exports = __webpack_public_path__ + "img/step_4.34ea2529.svg";